import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, unref as _unref, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "record-page" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = {
  key: 0,
  class: "mt-4 flex items-start"
}
const _hoisted_4 = { class: "text-sm text-gray-600" }
const _hoisted_5 = { class: "record-page__pair membership__cards" }
const _hoisted_6 = {
  key: 0,
  class: "flex justify-center py-6"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "membership__control"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "membership__control"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "membership__control"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 0,
  class: "membership__control"
}
const _hoisted_17 = { key: 1 }

import { DatePicker } from 'v-calendar'
import { computed, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

import BasicSpinner from '@/components/BasicSpinner.vue'
import MealPlanInfoCard from '@/components/customers/MealPlanInfoCard.vue'
import PassBenefits from '@/components/customers/PassBenefits.vue'
import PassInfoCard from '@/components/customers/PassInfoCard.vue'
import RecordButton from '@/components/customers/record/RecordButton.vue'
import RecordCard from '@/components/customers/record/RecordCard.vue'
import RecordRow from '@/components/customers/record/RecordRow.vue'
import SelectInput from '@/components/neue/SelectInput.vue'
import TheModal from '@/components/TheModal.vue'
import { contactSinceLabel, fetchCustomerPair } from '@/composables/useCustomerRecord'
import { useToast } from '@/composables/useToast'
import { dateObjectToServerDay, MEDIUM_DATE, serverDayToDateObject } from '@/helpers/dates'
import privilegeService from '@/services/privilege.service'
import api from '@/store/api'
import { mapRelationship, mapRelationships, mapType } from '@/store/mappers'


export default {
  __name: 'CustomerMembershipTab',
  setup(__props) {

const route = useRoute()
const store = useStore()
const { showToast } = useToast()

const mediumFormat = MEDIUM_DATE.format

const initialLocal = () => ({
  modal: { type: '', content: {} },
  effective: null,
  editingEffective: false,
  selectedPassId: null,
  pendingPass: null,
  showConfirmWarning: false
})

const loading = ref(true)
const local = ref(initialLocal())

const canUpdateCustomerProfile = computed(() =>
  privilegeService.canAccessResourceAction('customer_profile', null, 'update')
)

const conversationUserPair = computed(() => mapRelationship({ type: 'conversation_user_pair', id: route.params.id }))
const name = computed(() => conversationUserPair.value?.attributes?.display_name)
const contactSince = computed(() => contactSinceLabel(conversationUserPair.value))

const membershipPassSelection = computed(() =>
  conversationUserPair.value?.relationships?.membership_pass_selection?.data
    ? mapRelationship(conversationUserPair.value.relationships.membership_pass_selection.data)
    : null
)

const membershipTierSelection = computed(() =>
  conversationUserPair.value?.relationships?.membership_tier_selection?.data
    ? mapRelationship(conversationUserPair.value.relationships.membership_tier_selection.data)
    : null
)

const membershipTier = computed(() =>
  conversationUserPair.value?.relationships?.membership_tier?.data
    ? mapRelationship(conversationUserPair.value.relationships.membership_tier.data)
    : null
)

const membershipPass = computed(() =>
  membershipTier.value?.relationships?.membership_pass?.data
    ? mapRelationship(membershipTier.value.relationships.membership_pass.data)
    : null
)

const cartSubscription = computed(() =>
  mapRelationship(conversationUserPair.value?.relationships?.current_cart_subscription?.data)
)

const intervalOptions = computed(() =>
  mapRelationships(membershipTier.value?.relationships?.cart_subscription_settings?.data).filter(
    x => x.attributes.setting_name === 'interval'
  )
)

const packages = computed(() => mapRelationships(cartSubscription.value?.relationships?.possible_packages?.data))

const stores = computed(() =>
  mapRelationships(membershipTier.value?.relationships?.cart_subscription_store_options?.data)
)

const membershipTiers = computed(() => mapType('membership_tier'))

const passOptions = computed(() => {
  if (!membershipTier.value?.relationships?.membership_pass?.data) return []
  const mappedPass = mapRelationship(membershipTier.value.relationships.membership_pass.data)
  return [{ name: mappedPass?.attributes?.name, value: mappedPass?.id }]
})

const passSelected = computed(() =>
  Boolean(
    membershipTier.value &&
      membershipPass.value &&
      membershipPassSelection.value &&
      String(membershipPassSelection.value.attributes.membership_pass_id) === String(membershipPass.value.id)
  )
)

const memberSinceLine = computed(() => {
  const since = membershipTierSelection.value?.attributes?.created_at
  const tierName = membershipTier.value?.attributes?.tier_name
  return since && tierName ? `${tierName} member since ${mediumFormat(new Date(since))}` : ''
})

const loadPair = () => {
  const id = route.params.id
  loading.value = true
  return fetchCustomerPair(id)
    .then(() => {
      if (id !== route.params.id) return
      local.value.effective = serverDayToDateObject(cartSubscription.value?.attributes.effective_starting_date)
    })
    .catch(error => {
      if (id !== route.params.id) return
      showToast("Couldn't load the membership. Please try again.", { type: 'error' })
      throw error
    })
    .finally(() => {
      if (id === route.params.id) loading.value = false
    })
}

const getMembershipTiers = () => {
  api.call(
    'GET',
    'membership_tiers?included=cart_subscription_settings,cart_subscription_store_options,membership_pass,membership_pass.membership_pass_rewards'
  )
}

const setTier = id => {
  api
    .call(
      'POST',
      `conversation_user_pairs/${route.params.id}/membership_tier_selections?included=current_cart_subscription,current_cart_subscription.possible_packages,current_cart_subscription.package,membership_tier_selection`,
      { membership_tier_selection: { membership_tier_id: id } }
    )
    .then(() => {
      local.value.effective = serverDayToDateObject(cartSubscription.value?.attributes.effective_starting_date)
    })
}

const saveEffective = () => {
  api.call('POST', `conversation_user_pairs/${route.params.id}/cart_subscriptions`, {
    cart_subscription: { effective_starting_date: dateObjectToServerDay(local.value.effective) }
  })
  local.value.editingEffective = false
}

const saveCartSubscription = cartSubscriptionFields =>
  api.call('POST', `conversation_user_pairs/${route.params.id}/cart_subscriptions`, {
    cart_subscription: cartSubscriptionFields
  })

const setInterval = id => saveCartSubscription({ interval_cart_subscription_setting_id: id })
const setStore = id => saveCartSubscription({ store_id: id })
const setPackage = id => saveCartSubscription({ package_id: id })

const resetModalContent = () => {
  local.value.modal.type = ''
  local.value.modal.content = {}
  local.value.selectedPassId = null
  local.value.pendingPass = null
  local.value.showConfirmWarning = false
}

const handlePassSelect = id => {
  local.value.selectedPassId = id
  local.value.pendingPass = passOptions.value.find(p => p.value === id)
  local.value.modal.type = 'confirmPassSelection'
}

const confirmPassSelection = () => {
  const selectedPassId = local.value.selectedPassId
  resetModalContent()

  api.call('POST', `conversation_user_pairs/${route.params.id}/membership_passes?included=membership_pass_selection`, {
    membership_pass_selection: { membership_pass_id: selectedPassId }
  })
}

const handleConfirmClick = () => {
  if (!local.value.showConfirmWarning) {
    local.value.showConfirmWarning = true
    return
  }
  confirmPassSelection()
}

const cancelPass = passId => {
  api
    .call('DELETE', `/conversation_user_pairs/${route.params.id}/membership_passes/${passId}`, {}, { delete: false })
    .then(() => {
      store.commit('DESTROY_OBJECT_WITHOUT_ID', 'membership_pass_payment_transaction')
    })
}

const mealPlanSubscriptionIds = ref([])

const mealPlanSubscription = computed(() => {
  const subscriptions = mapType('meal_plan_subscription').filter(
    subscription =>
      mealPlanSubscriptionIds.value.includes(subscription.id) && subscription.attributes.status !== 'cancelled'
  )
  return subscriptions.sort((a, b) => Number(b.id) - Number(a.id))[0] || null
})

const getMealPlanSubscriptions = () => {
  const id = route.params.id
  api
    .call('GET', `conversation_user_pairs/${id}/meal_plan_subscriptions`)
    .then(response => {
      if (id !== route.params.id) return
      mealPlanSubscriptionIds.value = response.data.data.map(subscription => subscription.id)
    })
    .catch(() => {
      if (id !== route.params.id) return
      showToast("Couldn't load the meal plan subscription. Please try again.", { type: 'error' })
    })
}

const pauseMealPlan = () => {
  api
    .call('POST', `conversation_user_pairs/${route.params.id}/meal_plan_subscriptions/pauses`)
    .then(() => getMealPlanSubscriptions())
    .catch(() => showToast("Couldn't pause the meal plan. Please try again.", { type: 'error' }))
}

const resumeMealPlan = subscriptionId => {
  api
    .call(
      'DELETE',
      `conversation_user_pairs/${route.params.id}/meal_plan_subscriptions/pauses/${subscriptionId}`,
      {},
      { delete: false }
    )
    .then(() => getMealPlanSubscriptions())
    .catch(() => showToast("Couldn't resume the meal plan. Please try again.", { type: 'error' }))
}

const cancelMealPlan = subscriptionId => {
  api
    .call(
      'DELETE',
      `conversation_user_pairs/${route.params.id}/meal_plan_subscriptions/${subscriptionId}`,
      {},
      { delete: false }
    )
    .then(() => getMealPlanSubscriptions())
    .catch(() => showToast("Couldn't cancel the meal plan. Please try again.", { type: 'error' }))
}

const load = () => {
  const customerLoad = loadPair()
  getMembershipTiers()
  getMealPlanSubscriptions()
  return customerLoad
}

watch(
  () => route.params.id,
  () => {
    local.value = initialLocal()
    mealPlanSubscriptionIds.value = []
    return load()
  }
)

onMounted(load)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (local.value.modal.type === 'confirmPassSelection')
      ? (_openBlock(), _createBlock(TheModal, {
          key: 0,
          "is-open": local.value.modal.type === 'confirmPassSelection',
          "modal-title": `Assign ${local.value.pendingPass?.name} to ${name.value}`,
          onCloseModal: resetModalContent
        }, {
          main: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(PassBenefits, { "membership-pass": membershipPass.value }, null, 8, ["membership-pass"]),
              (local.value.showConfirmWarning)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                    _cache[3] || (_cache[3] = _createElementVNode("svg", {
                      class: "w-6 h-6 mr-2 text-red-600",
                      viewBox: "0 0 91.8 120",
                      fill: "currentColor"
                    }, [
                      _createElementVNode("path", { d: "M45.9,3.6c-23.5,0-42.5,19-42.5,42.5c0,23.5,19,42.5,42.5,42.5c23.5,0,42.5-19,42.5-42.5  C88.4,22.7,69.4,3.6,45.9,3.6z M43.7,21.1h4.3c0.5,0,0.9,0.4,0.9,0.9l-0.6,34.5c0,0.5-0.4,0.9-0.9,0.9h-3c-0.5,0-0.9-0.4-0.9-0.9  L42.8,22C42.8,21.5,43.2,21.1,43.7,21.1z M48.6,71.2c-0.8,0.8-1.7,1.1-2.7,1.1c-1,0-1.9-0.3-2.6-1c-0.8-0.7-1.3-1.8-1.3-2.9  c0-1,0.4-1.9,1.1-2.7c0.7-0.8,1.8-1.2,2.9-1.2c1.2,0,2.2,0.5,3,1.4c0.5,0.6,0.8,1.3,0.9,2.1C49.9,69.3,49.5,70.3,48.6,71.2z" })
                    ], -1)),
                    _createElementVNode("span", _hoisted_4, " Assigning the " + _toDisplayString(local.value.pendingPass?.name) + " would automatically charge " + _toDisplayString(name.value) + "'s account. Are you sure you want to continue? ", 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("button", {
              class: "btn-ghost justify-center",
              onClick: resetModalContent
            }, "Cancel"),
            _createElementVNode("button", {
              class: "btn-primary justify-center",
              onClick: handleConfirmClick
            }, _toDisplayString(local.value.showConfirmWarning ? 'Confirm' : 'Assign'), 1)
          ]),
          _: 1
        }, 8, ["is-open", "modal-title"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(RecordCard, {
        "data-test": "tier-card",
        title: "Tier",
        subtitle: memberSinceLine.value
      }, {
        default: _withCtx(() => [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(BasicSpinner, { color: "gray-900" })
              ]))
            : (_openBlock(), _createElementBlock("dl", _hoisted_7, [
                _createVNode(RecordRow, { label: "Membership tier" }, {
                  default: _withCtx(() => [
                    (canUpdateCustomerProfile.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createVNode(SelectInput, {
                            options: membershipTiers.value?.map(x => ({ name: x.attributes.tier_name, value: x.id })),
                            "model-value": membershipTier.value?.id,
                            "onUpdate:modelValue": setTier
                          }, null, 8, ["options", "model-value"])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(membershipTier.value?.attributes?.tier_name), 1))
                  ]),
                  _: 1
                }),
                _createVNode(RecordRow, { label: "Contact since" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(contactSince.value), 1)
                  ]),
                  _: 1
                }),
                (!passSelected.value && passOptions.value.length)
                  ? (_openBlock(), _createBlock(RecordRow, {
                      key: 0,
                      label: "Pass"
                    }, {
                      default: _withCtx(() => [
                        (canUpdateCustomerProfile.value)
                          ? (_openBlock(), _createBlock(RecordButton, {
                              key: 0,
                              "data-test": "add-pass",
                              size: "sm",
                              onClick: _cache[0] || (_cache[0] = $event => (handlePassSelect(passOptions.value[0]?.value)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Add to " + _toDisplayString(passOptions.value[0]?.name), 1)
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createElementBlock("span", _hoisted_10, "Not on the " + _toDisplayString(passOptions.value[0]?.name), 1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
        ]),
        _: 1
      }, 8, ["subtitle"]),
      (cartSubscription.value)
        ? (_openBlock(), _createBlock(RecordCard, {
            key: 0,
            "data-test": "subscription-card",
            title: "Subscription"
          }, {
            default: _withCtx(() => [
              _createElementVNode("dl", null, [
                _createVNode(RecordRow, {
                  label: "Next production",
                  active: local.value.editingEffective
                }, _createSlots({
                  default: _withCtx(() => [
                    (local.value.editingEffective && canUpdateCustomerProfile.value)
                      ? (_openBlock(), _createBlock(_unref(DatePicker), {
                          key: 0,
                          modelValue: local.value.effective,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((local.value.effective) = $event)),
                          mode: "date"
                        }, null, 8, ["modelValue"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(mediumFormat)(_unref(serverDayToDateObject)(cartSubscription.value?.attributes.next_upcoming_date))), 1))
                  ]),
                  _: 2
                }, [
                  (canUpdateCustomerProfile.value)
                    ? {
                        name: "action",
                        fn: _withCtx(() => [
                          (local.value.editingEffective)
                            ? (_openBlock(), _createBlock(RecordButton, {
                                key: 0,
                                "data-test": "save-next-production",
                                variant: "quiet",
                                size: "sm",
                                onClick: saveEffective
                              }, {
                                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                  _createTextVNode(" Save ", -1)
                                ]))]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(RecordButton, {
                                key: 1,
                                "data-test": "edit-next-production",
                                variant: "quiet",
                                size: "sm",
                                onClick: _cache[2] || (_cache[2] = $event => (local.value.editingEffective = true))
                              }, {
                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                  _createTextVNode(" Edit ", -1)
                                ]))]),
                                _: 1
                              }))
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["active"]),
                _createVNode(RecordRow, { label: "Interval" }, {
                  default: _withCtx(() => [
                    (canUpdateCustomerProfile.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createVNode(SelectInput, {
                            options: intervalOptions.value?.map(x => ({ name: x.attributes.display_description, value: x.id })),
                            "model-value": cartSubscription.value.relationships.interval_cart_subscription_setting.data?.id,
                            "onUpdate:modelValue": setInterval
                          }, null, 8, ["options", "model-value"])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(intervalOptions.value?.find(
                  x => x.id === cartSubscription.value.relationships.interval_cart_subscription_setting.data?.id
                )?.attributes.display_description), 1))
                  ]),
                  _: 1
                }),
                _createVNode(RecordRow, { label: "Default store" }, {
                  default: _withCtx(() => [
                    (canUpdateCustomerProfile.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(SelectInput, {
                            options: stores.value?.map(x => ({ name: x.attributes.store_name, value: x.id })),
                            "model-value": cartSubscription.value.relationships.store.data?.id,
                            "onUpdate:modelValue": setStore
                          }, null, 8, ["options", "model-value"])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(stores.value?.find(x => x.id === cartSubscription.value.relationships.store.data?.id)?.attributes.store_name), 1))
                  ]),
                  _: 1
                }),
                (packages.value.length)
                  ? (_openBlock(), _createBlock(RecordRow, {
                      key: 0,
                      label: "Package"
                    }, {
                      default: _withCtx(() => [
                        (canUpdateCustomerProfile.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createVNode(SelectInput, {
                                options: packages.value?.map(x => ({ name: x.attributes.package_name, value: x.id })),
                                "model-value": cartSubscription.value.relationships.package.data?.id,
                                "onUpdate:modelValue": setPackage
                              }, null, 8, ["options", "model-value"])
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(packages.value?.find(x => x.id === cartSubscription.value.relationships.package.data?.id)?.attributes.package_name), 1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (passSelected.value)
        ? (_openBlock(), _createBlock(RecordCard, {
            key: 1,
            "data-test": "pass-card",
            title: "Pass"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(PassInfoCard, {
                key: _unref(route).params.id,
                "membership-tier": membershipTier.value,
                "membership-pass": membershipPass.value,
                "is-loading": loading.value,
                "customer-name": name.value || '',
                "conversation-user-pair-id": String(_unref(route).params.id),
                "can-edit": canUpdateCustomerProfile.value,
                onCancelPass: cancelPass
              }, null, 8, ["membership-tier", "membership-pass", "is-loading", "customer-name", "conversation-user-pair-id", "can-edit"]))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (mealPlanSubscription.value)
        ? (_openBlock(), _createBlock(RecordCard, {
            key: 2,
            "data-test": "meal-plan-card",
            title: "Meal plan"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(MealPlanInfoCard, {
                key: _unref(route).params.id,
                "meal-plan-subscription": mealPlanSubscription.value,
                "meal-plan-subscription-ids": mealPlanSubscriptionIds.value,
                "is-loading": loading.value,
                "customer-name": name.value || '',
                "conversation-user-pair-id": String(_unref(route).params.id),
                "can-edit": canUpdateCustomerProfile.value,
                onPausePlan: pauseMealPlan,
                onResumePlan: resumeMealPlan,
                onCancelPlan: cancelMealPlan
              }, null, 8, ["meal-plan-subscription", "meal-plan-subscription-ids", "is-loading", "customer-name", "conversation-user-pair-id", "can-edit"]))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

}